import { FaRegEdit } from 'react-icons/fa'
import { FaCheck, FaTrashCan } from 'react-icons/fa6'
import { OverlayTrigger, Popover } from "react-bootstrap";
import { UserRole } from '../../../Data/UserRolesEnum.ts';
import useCheckUserRole from '../../BasketPage/Hooks/useCheckUserRole.ts';

const Address = ({ address, index, onDelete, onEdit, onSetMain }) => {
    function reverseDate(date) {
        try {
            const [year, month, day] = date.split('-')
            return `${day}-${month}-${year}`
        } catch {
            return ''
        }

    }

    const { isUserHasAccess } = useCheckUserRole()

    const popover = (text) => <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>{text}</span>
        </Popover.Body>
    </Popover>

    return (
        address &&
        <tr className='hoverable-row'>
            <td style={{ textAlign: 'center' }}>
                {index + 1}
            </td>
            <td>
                {address.name}
            </td>
            <td>
                {`${address.street}, ${address.zipCode} ${address.city}`}
            </td>
            <td>
                {address.phoneNumber ? address.phoneNumber : ''}
            </td>
            <td>{!address.effectiveDate || address.effectiveDate === '' ? 'Bezterminowy' : reverseDate(address.effectiveDate.substring(0, address.effectiveDate.indexOf('T')))}</td>
            {isUserHasAccess(UserRole.Admin) && <td style={{ textAlign: 'center' }}>
                {address.mainDeliveryAddress ? (<>
                    <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Główny adres dostawy')}>
                        <div>
                            <FaCheck className='primary-accent-color-text' />
                        </div>
                    </OverlayTrigger>
                </>)
                    :
                    <button onClick={() => onSetMain(address)} style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                        <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Ustaw jako główny adres dostawy')}>
                            <div>
                                <FaCheck className='light-text-color' />
                            </div>
                        </OverlayTrigger>
                    </button>}
            </td>}
            {isUserHasAccess(UserRole.Admin) && <td style={{ textAlign: 'center' }}>
                <button onClick={() => onEdit(address)} style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                    <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Edytuj')}>
                        <div>
                            <FaRegEdit color='black' />
                        </div>
                    </OverlayTrigger>
                </button>
            </td>}
            {isUserHasAccess(UserRole.Admin) && <td style={{ textAlign: 'center' }}>
                <button onClick={() => onDelete(address)} style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                    <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Usuń')}>
                        <div>
                            <FaTrashCan color='black' />
                        </div>
                    </OverlayTrigger>
                </button>
            </td>}
        </tr>
    )
}

export default Address
